import { useMemo, useState } from "react";

import { TaggingComponent } from "@components/TaggingComponent/TaggingComponent";
import { IAttribute, IRelationObject } from "@interfaces/attribute.interface";
import { ICompanyTag, IDealTag, IPeopleTag, Tag } from "@interfaces/tag.interface";

import { resolveAllowedTargets, toRelationObject } from "./utils";

interface RelationTagPickerProps {
  attribute: IAttribute;
  onSelect: (relation: IRelationObject) => void;
  /** Never offered — typically the host record. */
  excludedIds?: string[];
  /** Picked record ids (`object.id`, not the relation id), rendered as ticks. */
  selectedRecordIds?: string[];
  /** Off for single-select — nothing to untick. */
  showSelectedCheck?: boolean;
}

/** Record search bound to the attribute's allowed types. Owns only the query. */
export const RelationTagPicker = ({
  attribute,
  onSelect,
  excludedIds,
  selectedRecordIds,
  showSelectedCheck = true,
}: RelationTagPickerProps) => {
  const [query, setQuery] = useState("");

  // The targets are already the group keys sent as `types`.
  const tagTypes = useMemo(
    () => resolveAllowedTargets(attribute.relation_content_types),
    [attribute.relation_content_types]
  );

  return (
    <TaggingComponent
      query={query}
      onChange={setQuery}
      onSelect={(item: Tag) =>
        onSelect(toRelationObject(item as IDealTag | ICompanyTag | IPeopleTag))
      }
      keyForTypes="MERIDIAN_RECORD"
      tagTypes={tagTypes}
      excludedIds={excludedIds}
      selectedIds={selectedRecordIds}
      showSelectedCheck={showSelectedCheck}
      placeholder="Search"
      // Three per group before typing, as in oberon.
      recentLimit={3}
      uppercaseLabels
      isCompact
    />
  );
};
